import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const fetchAllPayments = query => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.payments
        .fetchAllPayments(query)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_PAYMENTS_FAILED,
              reject: actionTypes.FETCH_PAYMENTS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_PAYMENTS_LOADING);
  const success = res => action(actionTypes.FETCH_PAYMENTS_SUCCESS, res);

  return request();
};

export const fetchPaymentDetails = id => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.payments
        .fetchPaymentDetails(id)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.FETCH_PAYMENTDETAILS_FAILED,
              reject: actionTypes.FETCH_PAYMENTDETAILS_REJECT
            })
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.FETCH_PAYMENTDETAILS_LOADING);
  const success = res => action(actionTypes.FETCH_PAYMENTDETAILS_SUCCESS, res);

  return request();
};

export const getPaymentsExcelFile = query => {
  return function(dispatch) {
    dispatch(action(actionTypes.GET_PAYMENTS_EXCEL_FILE_LOADING));

    return API.payments
      .getPaymentsExcelFile(query)
      .then(res => {
        dispatch(action(actionTypes.GET_PAYMENTS_EXCEL_FILE_SUCCESS));

        return res;
      })
      .catch(err => {
        dispatch(
          generateErrorAction(err, {
            failure: actionTypes.GET_PAYMENTS_EXCEL_FILE_FAILED,
            reject: actionTypes.GET_PAYMENTS_EXCEL_FILE_REJECT
          })
        );

        throw err;
      });
  };
};
